// extracted by mini-css-extract-plugin
export default {"main":"Farming_main__AIJfR","main1":"Farming_main1__ECUnP","cover":"Farming_cover__gBEUo","flex_col":"Farming_flex_col__bMZ4s"};